import { ReactElement } from "react";
import { useDomainContext } from "@hooks/useDomainContext";
import { getKeyWordsForMetaTags } from "@components/severalbrands/utils";
import MetaTags from "@components/severalbrands/metaTags";
import HeroSection from "@components/severalbrands/HeroSection";
import ThirdSectionB2b from "@components/severalbrands/b2b/thirdSection";
import ForthSectionB2b from "@components/severalbrands/b2b/forthSection";
import { DomainInfo } from "@components/severalbrands/utils/services";
import LogoSlider from "@components/severalbrands/logoSlider";
import { getFinalLogosForLogoSLider } from "@components/severalbrands/utils";

export default function SeveralBrandsCategoryPage(): ReactElement {
    const { domain, category } = useDomainContext();

    const finalLogos = getFinalLogosForLogoSLider(
        domain.config?.sliderLogos,
        null,
    );

    const description = category?.metatags?.find(
        (meta) => meta.key === "description",
    )?.value;
    return (
        <>
            <MetaTags
                title={
                    category?.title ??
                    "Unleash Your Business's Growth Potential | SeveralBrands.com"
                }
                description={
                    description ??
                    "Discover how our expert lead generation tactics can supercharge your sales funnel. Book your consultation today!"
                }
                keyWords={getKeyWordsForMetaTags(domain as DomainInfo)}
            />
            <HeroSection />
            {finalLogos?.length > 0 && <LogoSlider logos={finalLogos} />}
            <ThirdSectionB2b />
            <ForthSectionB2b />
        </>
    );
}
